import { Invoice } from '../interfaces/user';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PaymentMethod } from '../interfaces/payment-method';
import { Observable } from 'rxjs';
import { createCustomHeader } from '../util/http.util';
import { Coupon } from '../../shared/payment/model/payment.model';

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  constructor(private http: HttpClient) {}

  payInvoice(invoice_uid: string, payment_method?: string): Observable<Invoice> {
    return this.http.post<Invoice>(
      environment.be_url + '/payments/customers/invoice/pay',
      {},
      createCustomHeader({
        target_resource: invoice_uid,
        custom_params: { 'Payment-Method': payment_method || 'bank_transfert' },
      })
    );
  }

  addPaymentMethod(card_number: string, expire_month: number, expire_year: number, cvv: string): Observable<PaymentMethod> {
    return this.http.put<PaymentMethod>(environment.be_url + '/payments/customers/payment_method', {
      number: card_number,
      exp_year: expire_year,
      exp_month: expire_month,
      cvc: cvv,
    });
  }

  public setPaymentMethodAsDefault(payment_method_id: string): Observable<void> {
    return this.http.post<void>(
      environment.be_url + '/payments/customers/payment_method',
      { favorite: true },
      createCustomHeader({
        target_resource: payment_method_id,
      })
    );
  }

  deletePaymentMethod(payment_method_id: string): Observable<void> {
    return this.http.delete<void>(
      environment.be_url + '/payments/customers/payment_method',
      createCustomHeader({
        target_resource: payment_method_id,
      })
    );
  }

  getUserReferral(): Observable<Coupon> {
    return this.http.get<Coupon>(environment.be_url + '/payments/v2/coupons/user');
  }
}
